module.exports = __webpack_public_path__ + "img/95.5de3b9b7.jpg";